import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

// Canonical / enum dimensions ONLY — messy free-text fields are deliberately not
// offered as filters (they'd fragment). Empty value ('') means "no filter".
const STATUS_OPTIONS = [
  { value: '', label: 'Active & Rejected' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'REJECTED', label: 'Rejected' },
];
const MSME_OPTIONS = [
  { value: '', label: 'All MSME' },
  { value: 'MSME', label: 'MSME' },
  { value: 'NON_MSME', label: 'Non-MSME' },
];
const ORIGIN_OPTIONS = [
  { value: '', label: 'All origins' },
  { value: 'IN', label: 'Indian' },
  { value: 'FOREIGN', label: 'Foreign' },
];
const REGION_OPTIONS = [
  { value: '', label: 'All regions' },
  { value: 'North', label: 'North' },
  { value: 'South', label: 'South' },
  { value: 'East', label: 'East' },
  { value: 'West', label: 'West' },
];
const CURRENCY_OPTIONS = [
  { value: '', label: 'All currencies' },
  ...['INR', 'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'AED', 'SGD', 'CHF', 'AUD'].map((c) => ({ value: c, label: c })),
];

const FIELD = 'flex flex-col gap-1';
const LABEL = 'text-[10px] font-medium uppercase tracking-[0.08em] text-dash-muted-foreground';

const FilterBar = ({ filters, onChange, onReset }) => {
  const set = (key) => (value) => onChange({ [key]: value });

  return (
    <div className="rounded-md border border-dash-border bg-dash-card p-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        <div className={FIELD}>
          <span className={LABEL}>From</span>
          <Input type="date" value={filters.dateFrom || ''} onChange={(e) => onChange({ dateFrom: e.target.value })} />
        </div>
        <div className={FIELD}>
          <span className={LABEL}>To</span>
          <Input type="date" value={filters.dateTo || ''} onChange={(e) => onChange({ dateTo: e.target.value })} />
        </div>
        <div className={FIELD}>
          <span className={LABEL}>Status</span>
          <Select options={STATUS_OPTIONS} value={filters.status || ''} onChange={set('status')} />
        </div>
        <div className={FIELD}>
          <span className={LABEL}>MSME</span>
          <Select options={MSME_OPTIONS} value={filters.msmeStatus || ''} onChange={set('msmeStatus')} />
        </div>
        <div className={FIELD}>
          <span className={LABEL}>Origin</span>
          <Select options={ORIGIN_OPTIONS} value={filters.countryOrigin || ''} onChange={set('countryOrigin')} />
        </div>
        <div className={FIELD}>
          <span className={LABEL}>Region</span>
          <Select options={REGION_OPTIONS} value={filters.region || ''} onChange={set('region')} />
        </div>
        <div className={FIELD}>
          <span className={LABEL}>Currency</span>
          <Select options={CURRENCY_OPTIONS} value={filters.currency || ''} onChange={set('currency')} searchable />
        </div>
        <div className="flex items-end">
          <Button variant="outline" size="sm" onClick={onReset} fullWidth>
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
